import gql from "graphql-tag";

export default {
  createBookAuthor: gql`
    mutation createBookAuthor(
      $book: String!,
      $author: String!,
      $role: String!,
      $sequence: Int!
    ) {
      createBookAuthor(input: {
        book: $book,
        author: $author,
        role: $role, 
        sequence: $sequence
      }) {
        bookAuthor {
          id
          author {
            id
            _id
            name
          }
          role {
            id
            _id
            description
          }
          sequence
        }
      }
    }
  `,
  
  deleteBookAuthor: gql`
    mutation deleteBookAuthor($id: ID!) {
      deleteBookAuthor(input: {id: $id}) {
        bookAuthor {
          id
        }
      }
    }
  `
};
